module.exports = __webpack_public_path__ + "static/media/v12m.e9f05e3a.mp4";